/**
 * Стандартный URLSearchParams не парсит #символы, и вообще находит только первый знак вопроса
 * https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams
 */

import { EChannel } from '../types/types';

interface IURLUtils {
    devEnabled: () => boolean;
    aiAssistantEnabled: () => boolean;
    getQueryString: () => string;
    // Сравнение N сегментов pathname, например /Mobile/Principles/Colors%20Set и /Mobile/Principles при segmentLevel=3 вернет true.
    isEqualPathname: (pathname1: string, pathname2: string, segmentLevel: number) => boolean;
}

const URLUtils: IURLUtils = {
    devEnabled: () => {
        const searchParams = new URLSearchParams(URLUtils.getQueryString());
        return searchParams.has('dev');
    },

    aiAssistantEnabled: () => {
        const searchParams = new URLSearchParams(URLUtils.getQueryString());
        return searchParams.has('ai-assistant');
    },

    getQueryString: () => window.location.search,

    isEqualPathname: (pathname1, pathname2, segmentLevel) => {
        const path1Arr = pathname1.split('/');
        const path2Arr = pathname2.split('/');
        let isEqual = true;

        for (let i = 0; i < segmentLevel; i++) {
            if (path1Arr[i] !== path2Arr[i]) {
                isEqual = false;
            }
        }

        return isEqual;
    },
};

export default URLUtils;
